import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function Method() {
  const pillars = ['sabor', 'saciedad', 'placer', 'menos pesadez', 'más constancia'];
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-98">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-warm-beige rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-x-1/2 -translate-y-1/2" data-id="element-99"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-olive-green/10 rounded-full mix-blend-multiply filter blur-3xl opacity-50 translate-x-1/3 translate-y-1/3" data-id="element-100"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-101">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-102">
          <div data-id="element-103">
            <FadeIn data-id="element-104">
              <span className="text-olive-green font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-105">
                Qué hace diferente a este método
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-warm-brown mb-8 leading-tight" data-id="element-106">
                El Método de la Sustitución Inteligente
              </h2>

              <div className="space-y-6 text-lg text-gray-600 mb-8" data-id="element-107">
                <p className="font-medium text-xl text-gray-800" data-id="element-108">
                  Aquí no se trata de eliminar todo.
                </p>
                <p data-id="element-109">
                  Se trata de cambiar estratégicamente la base de tus comidas
                  para mantener:
                </p>
              </div>
            </FadeIn>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10" data-id="element-110">
              {pillars.map((pillar, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-111">
                  <div className="flex items-center bg-warm-beige/40 rounded-lg p-4 border border-warm-beige" data-id="element-112">
                    <CheckCircle2 className="text-olive-green mr-3" size={20} data-id="element-113" />
                    <span className="font-medium text-gray-800 capitalize" data-id="element-114">
                      {pillar}
                    </span>
                  </div>
                </FadeIn>)}
            </div>
          </div>

          <FadeIn direction="left" delay={0.4} data-id="element-115">
            <div className="bg-olive-green rounded-3xl p-8 md:p-12 text-white shadow-xl relative" data-id="element-116">
              <div className="absolute -top-6 -right-6 text-9xl text-white/10 font-serif leading-none" data-id="element-117">
                "
              </div>
              <div className="space-y-8 relative z-10" data-id="element-118">
                <p className="text-2xl md:text-3xl font-serif leading-snug" data-id="element-119">
                  En lugar de castigo, usas estructura.
                </p>
                <div className="w-12 h-1 bg-warm-beige/50 rounded-full" data-id="element-120"></div>
                <p className="text-2xl md:text-3xl font-serif leading-snug" data-id="element-121">
                  En lugar de hambre, usas recetas que sí quieres repetir.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}